import React, { useEffect, useState } from 'react';
import styles from './circles-loader.module.scss';

export const Loader: React.FC = () => {
  const [activeIndexes, setActiveIndexes] = useState<number[]>([0]);
  const [direction, setDirection] = useState<number>(1);
  const [phase, setPhase] = useState<'animate' | 'steady' | 'dim'>('animate')

  useEffect(() => {
    const intervalId = setInterval(() => {
      if (phase === 'animate') {
        if (activeIndexes.includes(3) && direction === 1) {
          setDirection(-1);
        } else if (activeIndexes.includes(0) && direction === -1) {
          setDirection(1);
          setPhase('steady')
        }
        setActiveIndexes([activeIndexes[0] + direction])
      } else if (phase === 'steady') {
        if (activeIndexes.length < 5) {
          setActiveIndexes(prev => [...prev, prev[prev.length - 1] + 1])
        } else {
          setPhase('dim')
        }
      } else if (phase === 'dim') {
        if (activeIndexes.length > 0) {
          setActiveIndexes(prev => prev.slice(0, prev.length - 1))
        } else {
          setActiveIndexes([0])
          setPhase('animate')
        }
      }
    }, 200);

    return () => clearInterval(intervalId);
  }, [activeIndexes, direction, phase]);

  return (
    <div className={styles.loaderContainer}>
      {Array.from({ length: 4 }, (_, index) => (
        <div
          key={index}
          className={`${styles.loaderCircle} ${activeIndexes.includes(index) && styles.active}`}
        />
      ))}
    </div>
  );
};

export default Loader;
